import type { SoapAuthKind } from '../generated/types/nodes/soap'

export const SOAP_AUTH_KINDS = ['none', 'basic', 'ntlm'] as const satisfies readonly SoapAuthKind[]

export function isSoapAuthKind(value: unknown): value is SoapAuthKind {
  return typeof value === 'string' && (SOAP_AUTH_KINDS as readonly string[]).includes(value)
}

export function soapAuthUsesPassword(kind: SoapAuthKind): boolean {
  return kind === 'basic' || kind === 'ntlm'
}

export function soapAuthKindFromTagMode(tagMode: string | undefined): SoapAuthKind {
  return tagMode === 'basic' || tagMode === 'ntlm' ? tagMode : 'none'
}
